import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import { Modal, Button } from "react-bootstrap";
import { FaUserCircle, FaSignOutAlt } from "react-icons/fa";
import "../Assets/WebsiteCss/Topbar.css";

const Topbar = () => {
  const navigate = useNavigate();
  const [showLogoutModal, setShowLogoutModal] = useState(false);

  const handleLogoutConfirm = () => {
    localStorage.clear();
    sessionStorage.clear();
    toast.success("Logged out successfully");

    setShowLogoutModal(false);
    setTimeout(() => {
      navigate("/admin");
    }, 800);
  };

  return (
    <>
      {/* TOPBAR */}
      <div className="admin-topbar">
        <div className="admin-topbar-right">
          <FaUserCircle className="admin-avatar" />
          <span className="admin-name">Admin</span>

          <button
            className="logout-btn"
            onClick={() => setShowLogoutModal(true)}
          >
            <FaSignOutAlt size={14} /> Logout
          </button>
        </div>
      </div>

      {/* LOGOUT MODAL */}
      <Modal
        show={showLogoutModal}
        onHide={() => setShowLogoutModal(false)}
        centered
        backdrop="static"
      >
        <Modal.Header closeButton>
          <Modal.Title>Confirm Logout</Modal.Title>
        </Modal.Header>

        <Modal.Body>Are you sure you want to logout?</Modal.Body>

        <Modal.Footer>
          <Button
            className="logout-cancel-btn"
            onClick={() => setShowLogoutModal(false)}
          >
            Cancel
          </Button>

          <Button className="logout-confirm-btn" onClick={handleLogoutConfirm}>
            Logout
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default Topbar;
